import React from 'react';

import styles from './ContactActionsLayout.css';

interface IContactActionsLayoutProps {
  phoneButton: React.ReactNode;
  bookButton: React.ReactNode;
  showMoreOffersLink: React.ReactNode;
  chatButton: React.ReactNode;
}

export function ContactActionsLayout({
  phoneButton,
  bookButton,
  showMoreOffersLink,
  chatButton,
}: IContactActionsLayoutProps) {
  return (
    <div className={styles['wrapper']}>
      {showMoreOffersLink}
      {phoneButton && <div className={styles['button']}>{phoneButton}</div>}
      {chatButton && <div className={styles['button']}>{chatButton}</div>}
      {bookButton && <div className={styles['button']}>{bookButton}</div>}
    </div>
  );
}
